import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_app.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mdi/font/scss/materialdesignicons.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/index.scss");
